import Vue from "vue";
import Vuex, { StoreOptions } from "vuex";
import { RootState } from "./types";

Vue.use(Vuex);

const store: StoreOptions<RootState> = {
  modules: {},
  strict: process.env.NODE_ENV == "production" ? false : true
};

export default new Vuex.Store(store);
